export default __webpack_public_path__ + "static/media/mb-logo.d74f20a8.png";